import React from 'react';

export default function PaymentOkIcon() {
  return (
    <svg
      width="20px"
      height="20px"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="-1 -1 30 30"
    >
      <path
        d="M14 0c7.732 0 14 6.268 14 14s-6.268 14-14 14S0 21.732 0 14 6.268 0 14 0zm0 2.333C7.557 2.333 2.333 7.557 2.333 14S7.557 25.667 14 25.667 25.667 20.443 25.667 14 20.443 2.333 14 2.333zM19.133 8.4l2.334 2.427-9.334 9.706-5.6-5.824 2.334-2.425 3.266 3.396 7-7.28z"
        fillRule="nonzero"
      />
    </svg>
  );
}
